module.exports = __webpack_public_path__ + "static/img/ithelp.3e94667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/ithelp.jpg
// module id = UTPi
// module chunks = 1